import { NgModule } from '@angular/core';

import { CodemirrorComponent } from './codemirror.component';

@NgModule({
  exports: [CodemirrorComponent],
  declarations: [CodemirrorComponent],
})
export class CodemirrorModule {}
